/**
 * 9AND3 Weight Estimator — Modal Widget
 * Loads regression config from external JSON, auto-fills from product page selectors.
 */
(function() {
  'use strict';

  // ===== CONFIG — prefer embedded config, fallback to external fetch =====
  var CONFIG_URL = 'https://www.perplexity.ai/computer/a/9and3-weight-estimator-8rDLCfT.QtSR8YEYYtBENg/widget_config.json';

  var MODELS = {};
  var configLoaded = false;
  var configLoading = false;
  var configCallbacks = [];

  // Check for embedded config (loaded via weight-estimator-config.js)
  if (window.__WEIGHT_ESTIMATOR_CONFIG__) {
    MODELS = window.__WEIGHT_ESTIMATOR_CONFIG__;
    configLoaded = true;
  }

  var LUG_ADJUSTMENTS = {'4': -0.4, '5': 0, '6': 0, '8': 0.35};

  var BOLT_PATTERNS = {
    '5x114.3': {lugs: 5, label: '5x114.3 (5x4.5)'},
    '5x120':   {lugs: 5, label: '5x120'},
    '5x127':   {lugs: 5, label: '5x127 (5x5) — Jeep JK/JL'},
    '5x130':   {lugs: 5, label: '5x130 — Sprinter / G-Wagon'},
    '5x139.7': {lugs: 5, label: '5x139.7 (5x5.5) — Jeep / Ram 1500'},
    '5x150':   {lugs: 5, label: '5x150 — Tundra / Land Cruiser'},
    '6x120':   {lugs: 6, label: '6x120'},
    '6x135':   {lugs: 6, label: '6x135 — Ford F-150 / Raptor'},
    '6x139.7': {lugs: 6, label: '6x139.7 (6x5.5) — GM / Toyota'},
    '8x165.1': {lugs: 8, label: '8x165.1 (8x6.5) — GM HD / Dodge'},
    '8x170':   {lugs: 8, label: '8x170 — Ford Super Duty'},
    '8x180':   {lugs: 8, label: '8x180 — GM HD 2011+'}
  };

  var DIAMETERS = [17, 18, 20, 22];
  var WIDTHS = [7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 12];
  var KG_TO_LBS = 2.205;

  // ===== LOAD CONFIG =====
  function loadConfig(callback) {
    if (configLoaded) { callback(true); return; }

    configCallbacks.push(callback);
    if (configLoading) return; // already fetching
    configLoading = true;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', CONFIG_URL + '?v=' + Date.now(), true);
    xhr.timeout = 10000; // 10 second timeout
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          MODELS = JSON.parse(xhr.responseText);
          configLoaded = true;
          configLoading = false;
          for (var i = 0; i < configCallbacks.length; i++) configCallbacks[i](true);
          configCallbacks = [];
        } catch(e) {
          configLoading = false;
          for (var j = 0; j < configCallbacks.length; j++) configCallbacks[j](false);
          configCallbacks = [];
        }
      } else {
        configLoading = false;
        for (var k = 0; k < configCallbacks.length; k++) configCallbacks[k](false);
        configCallbacks = [];
      }
    };
    xhr.onerror = xhr.ontimeout = function() {
      configLoading = false;
      for (var i = 0; i < configCallbacks.length; i++) configCallbacks[i](false);
      configCallbacks = [];
    };
    xhr.send();
  }

  // ===== EXTRACT MODEL FROM PRODUCT TITLE =====
  function extractModel(title) {
    if (!title) return null;
    var match = title.match(/\b(FR[S]?-\d+[A-Z]*|TX[S]?-\d+[A-Z]*|XR[S]?-\d+[A-Z]*|SS-\d+[A-Z]*|RT-\d+[A-Z]*)\b/i);
    return match ? match[1].toUpperCase() : null;
  }

  // ===== EXTRACT BOLT PATTERN FROM PAGE =====
  function extractBoltFromPage() {
    var blocks = document.querySelectorAll('.product-form__option');
    for (var i = 0; i < blocks.length; i++) {
      var label = blocks[i].querySelector('.product-form__option-name');
      if (label && /bolt/i.test(label.textContent)) {
        var selected = blocks[i].querySelector('.block-swatch--selected .block-swatch__item-text, input:checked + label .block-swatch__item-text');
        if (selected) return selected.textContent.trim();
        var sel = blocks[i].querySelector('select');
        if (sel && sel.value) return sel.value;
      }
    }
    return null;
  }

  // ===== EXTRACT DIAMETER FROM PAGE =====
  function extractDiameterFromPage() {
    var blocks = document.querySelectorAll('.product-form__option');
    for (var i = 0; i < blocks.length; i++) {
      var label = blocks[i].querySelector('.product-form__option-name');
      if (label && /diameter/i.test(label.textContent)) {
        var selected = blocks[i].querySelector('.block-swatch--selected .block-swatch__item-text, input:checked + label .block-swatch__item-text');
        if (selected) {
          var num = parseFloat(selected.textContent.replace(/[^0-9.]/g, ''));
          return isNaN(num) ? null : num;
        }
        var sel = blocks[i].querySelector('select');
        if (sel && sel.value) {
          var num2 = parseFloat(sel.value.replace(/[^0-9.]/g, ''));
          return isNaN(num2) ? null : num2;
        }
      }
    }
    return null;
  }

  // ===== MATCH BOLT PATTERN =====
  function matchBoltPattern(bpString) {
    if (!bpString) return '';
    var cleaned = bpString.trim();
    if (BOLT_PATTERNS[cleaned]) return cleaned;
    for (var key in BOLT_PATTERNS) {
      if (cleaned.indexOf(key) !== -1 || BOLT_PATTERNS[key].label.indexOf(cleaned) !== -1) {
        return key;
      }
    }
    var match = cleaned.match(/(\d)x(\d{2,3}(?:\.\d)?)/);
    if (match) {
      var candidate = match[1] + 'x' + match[2];
      if (BOLT_PATTERNS[candidate]) return candidate;
    }
    return '';
  }

  // ===== CALCULATE =====
  function calculate(modelName, boltKey, diameter, width) {
    if (!modelName || !MODELS[modelName] || !boltKey || !BOLT_PATTERNS[boltKey] || isNaN(diameter) || isNaN(width)) {
      return null;
    }

    var model = MODELS[modelName];
    var bolt = BOLT_PATTERNS[boltKey];
    var lugs = bolt.lugs;
    var lugAdj = LUG_ADJUSTMENTS[String(lugs)] || 0;

    var weightKg, maeKg, r2, isExtrapolating = false;

    if (model.method === 'limited') {
      var avgBarrelArea = model.avg_diameter * model.avg_width;
      var targetBarrelArea = diameter * width;
      weightKg = model.avg_weight_kg * (targetBarrelArea / avgBarrelArea);
      maeKg = 1.0;
      r2 = null;
      if (diameter < model.min_diameter || diameter > model.max_diameter ||
          width < model.min_width || width > model.max_width) {
        isExtrapolating = true;
      }
    } else {
      weightKg = model.coef_diameter * diameter + model.coef_width * width + model.intercept;
      maeKg = model.mae_kg || 1.0;
      r2 = model.r2;
      if (diameter < model.min_diameter || diameter > model.max_diameter ||
          width < model.min_width || width > model.max_width) {
        isExtrapolating = true;
      }
    }

    weightKg += lugAdj;

    var weightLbs = weightKg * KG_TO_LBS;
    var maeLbs = maeKg * KG_TO_LBS;

    var confidence;
    if (model.method === 'limited') {
      confidence = isExtrapolating ? 'low' : 'medium';
    } else if (r2 !== null) {
      if (isExtrapolating) {
        confidence = r2 >= 0.90 ? 'medium' : 'low';
      } else {
        if (r2 >= 0.85 && model.n_configs >= 4) confidence = 'high';
        else if (r2 >= 0.60) confidence = 'medium';
        else confidence = 'low';
      }
    } else {
      confidence = 'low';
    }

    return {
      weight: weightLbs,
      low: weightLbs - maeLbs,
      high: weightLbs + maeLbs,
      confidence: confidence,
      isExtrapolating: isExtrapolating
    };
  }

  // ===== POPULATE HELPERS =====
  function populateSelect(el, data, labelKey) {
    el.innerHTML = '<option value="">— Select —</option>';
    for (var key in data) {
      var opt = document.createElement('option');
      opt.value = key;
      opt.textContent = data[key][labelKey];
      el.appendChild(opt);
    }
  }

  function populateSizes(el, sizes) {
    el.innerHTML = '<option value="">—</option>';
    for (var i = 0; i < sizes.length; i++) {
      var opt = document.createElement('option');
      opt.value = sizes[i];
      opt.textContent = sizes[i] + '"';
      el.appendChild(opt);
    }
  }

  // ===== UPDATE RESULT =====
  function updateResult(currentModel, boltSelect, diaSelect, widthSelect, resultArea) {
    var boltKey = boltSelect.value;
    var diameter = parseFloat(diaSelect.value);
    var width = parseFloat(widthSelect.value);

    if (!currentModel || !boltKey || isNaN(diameter) || isNaN(width)) {
      resultArea.innerHTML = '<div class="we-result--placeholder">Select your specs above</div>';
      return;
    }

    var result = calculate(currentModel, boltKey, diameter, width);
    if (!result) {
      resultArea.innerHTML = '<div class="we-result--placeholder">Unable to estimate</div>';
      return;
    }

    var confLabels = {high: 'High confidence', medium: 'Moderate confidence', low: 'Rough estimate'};
    var html = '<div class="we-result__label">Estimated Weight</div>';
    html += '<div class="we-result__weight">' + result.weight.toFixed(1) + '<span class="we-result__unit">lbs</span></div>';
    html += '<div class="we-result__range">' + result.low.toFixed(1) + ' – ' + result.high.toFixed(1) + ' lbs range</div>';
    html += '<div class="we-result__confidence we-result__confidence--' + result.confidence + '">';
    html += '<span class="we-confidence-dot"></span>' + confLabels[result.confidence] + '</div>';
    if (result.isExtrapolating) {
      html += '<div class="we-result__warning is-visible">Outside tested range — estimate may be less accurate</div>';
    }
    html += '<div class="we-result__disclaimer">Estimated weight based on production data. Actual weight may vary slightly.</div>';
    resultArea.innerHTML = html;
  }

  // ===== SHOW MODAL =====
  function showOverlay(overlay) {
    overlay.style.display = 'flex';
    overlay.style.opacity = '0';
    // Force reflow
    void overlay.offsetWidth;
    overlay.style.transition = 'opacity 0.2s ease';
    overlay.style.opacity = '1';
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  // ===== HIDE MODAL =====
  function hideOverlay(overlay) {
    overlay.style.opacity = '0';
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(function() {
      overlay.style.display = 'none';
    }, 200);
  }

  // ===== OPEN MODAL =====
  function openModal() {
    var overlay = document.getElementById('we-modal-overlay');
    var boltSelect = document.getElementById('we-bolt-select');
    var diaSelect = document.getElementById('we-diameter-select');
    var widthSelect = document.getElementById('we-width-select');
    var resultArea = document.getElementById('we-result');
    var modelTagEl = document.getElementById('we-model-tag');
    var modelNameEl = document.getElementById('we-model-name');

    if (!overlay || !boltSelect) return;

    // Show modal immediately — don't wait for config
    showOverlay(overlay);

    // Detect model from product title
    var titleEl = document.querySelector('.product-meta__title, .product__title, h1');
    var title = titleEl ? titleEl.textContent : '';
    var currentModel = extractModel(title);

    // Populate dropdowns (these don't need config)
    populateSelect(boltSelect, BOLT_PATTERNS, 'label');
    populateSizes(diaSelect, DIAMETERS);
    populateSizes(widthSelect, WIDTHS);

    // Auto-fill bolt pattern from page
    var pageBolt = extractBoltFromPage();
    var matchedBolt = matchBoltPattern(pageBolt);
    if (matchedBolt) boltSelect.value = matchedBolt;

    // Auto-fill diameter from page
    var pageDia = extractDiameterFromPage();
    if (pageDia) diaSelect.value = pageDia;

    // Wire up change listeners
    function onChangeHandler() {
      updateResult(currentModel, boltSelect, diaSelect, widthSelect, resultArea);
    }
    boltSelect.onchange = onChangeHandler;
    diaSelect.onchange = onChangeHandler;
    widthSelect.onchange = onChangeHandler;

    // Show loading state while config loads
    if (!configLoaded) {
      resultArea.innerHTML = '<div class="we-result--placeholder">Loading weight data...</div>';
    }

    // Load config then update model tag and result
    loadConfig(function(success) {
      if (success && currentModel && MODELS[currentModel]) {
        modelNameEl.textContent = currentModel;
        modelTagEl.style.display = '';
      } else {
        modelTagEl.style.display = 'none';
      }

      if (success) {
        onChangeHandler();
      } else {
        resultArea.innerHTML = '<div class="we-result--placeholder" style="color:#c62828;">Unable to load weight data. Please try again.</div>';
      }
    });
  }

  // ===== INIT =====
  function init() {
    // Use event delegation on document so it works for dynamically injected triggers
    // (e.g. trust bar item added by custom.js after DOM ready)
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-weight-estimator-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }
    });

    // Also handle keyboard activation for accessibility (Enter/Space on trust bar item)
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var trigger = e.target.closest('[data-weight-estimator-trigger]');
        if (trigger) {
          e.preventDefault();
          openModal();
        }
      }
    });

    // Close on close button click
    document.addEventListener('click', function(e) {
      var closeBtn = e.target.closest('#we-modal-close');
      if (closeBtn) {
        var overlay = document.getElementById('we-modal-overlay');
        if (overlay) hideOverlay(overlay);
      }
    });

    // Close on overlay background click
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'we-modal-overlay') {
        hideOverlay(e.target);
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var overlay = document.getElementById('we-modal-overlay');
        if (overlay && overlay.classList.contains('is-visible')) {
          hideOverlay(overlay);
        }
      }
    });

    // Pre-fetch config in background so it's ready when user clicks
    // (only needed if embedded config wasn't available)
    if (!configLoaded) loadConfig(function() {});
  }

  // Init when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

